import { render, staticRenderFns } from "./AppAgendaAlunos.vue?vue&type=template&id=66f7ffc0&scoped=true&"
import script from "./AppAgendaAlunos.vue?vue&type=script&lang=js&"
export * from "./AppAgendaAlunos.vue?vue&type=script&lang=js&"
import style0 from "./AppAgendaAlunos.vue?vue&type=style&index=0&id=66f7ffc0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f7ffc0",
  null
  
)

export default component.exports